import { TFunction } from 'react-i18next'
import { MailContactType, PhoneContactType, WebContactType } from 'src/api/api.generated'

export function displayMailContactType(t: TFunction<'translation', undefined>, type: MailContactType): string {
  const key = `commons.mail_contact_type.${type.toLowerCase()}`
  return t(key as any)
}

export function displayPhoneContactType(t: TFunction<'translation', undefined>, type: PhoneContactType): string {
  const key = `commons.phone_contact_type.${type.toLowerCase()}`
  return t(key as any)
}

export function displayWebContactType(t: TFunction<'translation', undefined>, type: WebContactType): string {
  const key = `commons.web_contact_type.${type.toLowerCase()}`
  return t(key as any)
}

export function isEmail(text: string | undefined | null): boolean {
  if (!text) return false
  const match = String(text)
    .toLowerCase()
    .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
  return match ? true : false
}

export function isPhoneNumber(text: string | undefined | null): boolean {
  if (!text) return false
  const match = String(text)
    .toLowerCase()
    .match(/^[0-9+][0-9-. /]{5,17}$/)
  return match ? true : false
}

export function isURL(text: string | undefined | null): boolean {
  if (!text) return false
  const match = String(text)
    .toLowerCase()
    .match(/^(http|https):\/\/.[-a-zA-Z0-9@:%._\\+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&=\\/]*)$/)
  return match ? true : false
}